// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

require('../src/assets/css/reset.css')

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 自己封装插件
import UrlMapping from './assets/js/UrlMapping'
Vue.prototype.$Urls = new UrlMapping()
import Axios from './assets/js/Axios'
Vue.prototype.$Axios = Axios

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'ENXvfKKQ11NonRNg4FqrgxTz6xYr5WFz'
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js